import fastdom from 'fastdom';
import fastdomPromised from 'fastdom/extensions/fastdom-promised';

export const fastDom = fastdom.extend(fastdomPromised);
